// extracted by mini-css-extract-plugin
export default {"root":"AccordionItemHeaderActive_root__1fmrE","placeHolderShimmer":"AccordionItemHeaderActive_placeHolderShimmer__YgOiT"};